// src/api/subject/subjectQueries.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import {
    createSubject,
    getSubject,
    updateSubject,
    deleteSubject,
    getAllSubjects
} from './subjectApi';

// Get a single subject by ID
export const useGetSubject = (subjectId) => {
    return useQuery({
        queryKey: ['subject', subjectId],
        queryFn: () => getSubject(subjectId),
        enabled: !!subjectId,
    });
};

// Create a new subject
export const useCreateSubject = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createSubject,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['subjects'] });
            toast.success('Subject created successfully');
        },
        onError: (error) => {
            console.error('Error creating subject:', error);
            toast.error(error.response?.data?.message || 'Failed to create subject');
        }
    });
};

// Update an existing subject
export const useUpdateSubject = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateSubject,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['subject', variables.subjectId] });
            queryClient.invalidateQueries({ queryKey: ['subjects'] });
            toast.success('Subject updated successfully');
        },
        onError: (error) => {
            console.error('Error updating subject:', error);
            toast.error(error.response?.data?.message || 'Failed to update subject');
        }
    });
};

// Delete a subject
export const useDeleteSubject = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteSubject,
        onSuccess: (data, subjectId) => {
            queryClient.invalidateQueries({ queryKey: ['subject', subjectId] });
            queryClient.invalidateQueries({ queryKey: ['subjects'] });
            toast.success('Subject deleted successfully');
        },
        onError: (error) => {
            console.error('Error deleting subject:', error);
            toast.error(error.response?.data?.message || 'Failed to delete subject');
        }
    });
};

// Get all subjects
export const useGetAllSubjects = () => {
    return useQuery({
        queryKey: ['subjects'],
        queryFn: getAllSubjects,
    });
};